import React from 'react';
import { styled } from '@mui/system';
import Box from '@mui/material/Box';

import { CHILDREN_PROP_TYPES } from 'propTypes';

const StyledBox = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    display: 'block'
  },
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  }
}));

const Flex = ({ children }) => {
  return <StyledBox>{children}</StyledBox>;
};

Flex.propTypes = { children: CHILDREN_PROP_TYPES.isRequired };

export default Flex;
